import { config } from '#config/configuration';
import { createRouter, createWebHistory } from 'vue-router';
import { routeDefinitions } from './definitions';
import { authGuard } from './guards/auth.guard';
import { onboardingGuard } from './guards/onboarding.guard';
import { permissionGuard } from './guards/permission.guard';
import { trackPageView } from './hooks/analytics.hook';
import './types';

const router = createRouter({
  history: createWebHistory(config.baseUrl),
  routes: routeDefinitions
});

/**
 * Execute guards sequentially.
 * authGuard handles system-wide initialization and basic authentication redirect.
 * permissionGuard handles KPI access, Roles, and Sandbox boundaries.
 * onboardingGuard handles redirecting to the onboarding flow if required.
 */
router.beforeEach(async (to, from) => {
  const dummyNext = () => {};

  const authResult = await authGuard(to, from, dummyNext);
  if (authResult !== undefined) {
    return authResult;
  }

  const onboardingResult = onboardingGuard(to, from, dummyNext);
  if (onboardingResult !== undefined) {
    return onboardingResult;
  }
  if (!to.meta.isOnboarding) {
    const permissionResult = permissionGuard(to, from, dummyNext);
    if (permissionResult !== undefined) {
      return permissionResult;
    }
  }
});

router.afterEach(trackPageView);

export default router;
